import React from "react";
import { Link as ScrollLink } from "react-scroll";

import { Box, ColorMode, IconButton } from "components";

function ScrollButton({}) {
  return (
    <Box
      data-component-id="homeHero.scrollButton"
      position="absolute"
      right={{ _: "initial", lg: "layout.5" }}
      bottom={{ _: "layout.3", md: "layout.4", lg: "layout.5" }}
      left={{ _: "layout.3", md: "layout.4", lg: "initial" }}
    >
      <ColorMode mode="light">
        <ScrollLink to="home-body" smooth={true}>
          <IconButton
            symbol="arrow-down-line"
            intent="default"
            appearance="primary"
            height={44}
            borderRadius={44}
          />
        </ScrollLink>
      </ColorMode>
    </Box>
  );
}

export default ScrollButton;
